import React, { useEffect, useState } from 'react'
import Grid from "@mui/material/Grid";
import Banner from './Banner';
import Years from './Years';
import Scholarships from './Scholarships';
import PopularCourses from './PopularCourses';
import OutstandingResults from './OutstandingResults';
import Testimonials from './Testimonials';
import TalkToOurExpert from './TalkToOurExpert';
import AakashAdvantage from './AakashAdvantage';
import FaqSection from './FaqSection';
import AutoPopUp from './AutoPopUp';
import Courses from './Courses';
import Header from '../common/Header';
import OffersHome from './OffersHome';


const HomePage = () => {

    const [isAutoPopupOpen, setIsAutoPopupOpen] = useState(false);

    const handleOpenAutoPopup = () => {
        const formSubmitted = sessionStorage.getItem("isFormSubmited");
        if (!formSubmitted) {
            setIsAutoPopupOpen(true);
        }
    };

    const handleCloseAutoPopup = () => {
        setIsAutoPopupOpen(false);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            handleOpenAutoPopup();
        }, 11000);

        return () => clearTimeout(timeout)
    }, [])

    return (
        <Grid>
            <Header />
            <div id="banner"><Banner /></div>
            <div id="our-centers"><Years /></div>
            <div id="scholarships"><Scholarships /></div>
            <div id="scholarships"><OffersHome /></div>
            <div id="popular-courses"><Courses /></div>
            <div id=""><PopularCourses /></div>
            <div id="outstanding-results"><OutstandingResults /></div>
            <div id="jee-rank"><Testimonials /></div>
            <div id="student-hub"><TalkToOurExpert /></div>
            <div id="blog"><AakashAdvantage /></div>
            <div id="faq"><FaqSection /></div>

            <AutoPopUp
                isOpen={isAutoPopupOpen}
                onClose={handleCloseAutoPopup}
                leadFlag="Organic"
            />

        </Grid>

    )
}

export default HomePage